import { ProductPurchaseOption, ProductPurchaseType } from '../productMap';
import { NewM1Data } from './IN';

export const newM1Data: NewM1Data = {
  [ProductPurchaseOption.oneTimePurchase]: {
    title: 'One Time Purchase',
    defaultProduct: ProductPurchaseType.otp_3_month_us,
    directCheckout: true,
    outOfStock: false,
    plans: {
      [ProductPurchaseType.otp_1_month_us]: {
        displayName: '1 Month',
        price: 129,
        variantId: '',
        internalPid: ProductPurchaseType.otp_1_month_us,
        secondaryImage: '',
        title: '1 Month',
        subtitle1: '2 CGM Sensors',
        subtitle2: 'Delivery on purchase',
        checkoutUrl: 'https://buy.stripe.com/28E3cveTL7oN3THaFe4803M',
      },
      [ProductPurchaseType.otp_3_month_us]: {
        displayName: '3 Months',
        price: 289,
        variantId: '',
        internalPid: ProductPurchaseType.otp_3_month_us,
        secondaryImage: '',
        title: '3 Months',
        subtitle1: '6 CGM Sensors',
        subtitle2: 'Delivery on purchase',
        checkoutUrl: 'https://buy.stripe.com/8x2fZh6nfgZneyl5kU4803O',
        tag: <>save 25%</>,
      },
      [ProductPurchaseType.otp_1_year_us]: {
        displayName: '1 Year',
        price: 1229,
        variantId: '',
        internalPid: ProductPurchaseType.otp_1_year_us,
        secondaryImage: '',
        title: '1 Year',
        subtitle1: '26 CGM Sensors',
        subtitle2: 'Delivered in 4 shipments',
        checkoutUrl: 'https://buy.stripe.com/dRmdR9eTLaAZeylcNm4803P',
        tag: <>save 27%</>,
      },
    },
  },
  [ProductPurchaseOption.membership]: {
    title: 'Subscription',
    defaultProduct: ProductPurchaseType.membership_1_sensor_month_us,
    directCheckout: true,
    plans: {
      [ProductPurchaseType.membership_1_sensor_month_us]: {
        displayName: '2 Sensors',
        price: 99,
        variantId: '',
        internalPid: ProductPurchaseType.membership_1_sensor_month_us,
        checkoutUrl: 'https://buy.stripe.com/aFa14ndPH24teyl6oY4803N',
        secondaryImage: '',
        title: '2 Sensors',
        subtitle1: '2 CGM Sensors/Month',
        subtitle2: 'Delivered monthly',
        tag: <>save 23%</>,
      },
    },
  },
};

export const m1data: Record<
  string,
  Array<Record<string, string | HTMLImageElement | number>> | boolean
> = {
  taxInclusive: false,
  plans: [
    {
      displayName: 'Ultrahuman M2 Live | 4 weeks continuous glucose monitoring',
      price: 199,
      variantId: 'gid://shopify/ProductVariant/40718088372284',
      internalPid: 'otp_4_weeks_eu',
      secondaryImage: '',
    },
    {
      displayName:
        'Ultrahuman M2 Live | 12 weeks continuous glucose monitoring',
      price: 559,
      variantId: 'gid://shopify/ProductVariant/40718094860348',
      internalPid: 'otp_12_weeks_eu',
      secondaryImage: '',
    },
  ],
};
